export default Object.freeze({
  CARRIED: 'carried',
  LOST: 'lost',
  WITHDRAWN: 'withdrawn',
  UNFINISHED: 'unfinished',
  MOVED_TO_MAIN: 'main',
  DIVISION_CARRIED: 'division_carried',
  DIVISION_LOST: 'division_lost'
})



// WEBPACK FOOTER //
// ./src/enums/motion-state-reason.js